// extracted by mini-css-extract-plugin
export default {"imageWrapper":"pG-z","hovered":"qG-z","hoverImage":"rG-z","mainImage":"sG-z","imageNoBackground":"tG-z","fullSizeImage":"uG-z"};